import { useQuery } from "@tanstack/react-query";

import { supabase } from "@/shared/lib/supabase";
import { AUTHORITY_TASK_IDS } from "@/shared/constants/taskIds";

export function useHasCourtDocs(estateId: number | undefined) {
  const { data: hasCourtDocs = false, isLoading } = useQuery({
    queryKey: ["hasCourtDocs", estateId],
    queryFn: async () => {
      const { data: tasks } = await supabase
        .from("estate_tasks")
        .select("answers")
        .eq("estate_id", estateId!)
        .in("task_id", [...AUTHORITY_TASK_IDS]);

      return (tasks ?? []).some((task) => {
        const answers = task.answers as Record<string, unknown> | null;
        return !!answers?.confirmed;
      });
    },
    enabled: !!estateId,
  });

  return { hasCourtDocs, isLoading };
}
